export default __webpack_public_path__ + "static/media/logo-light.1f8247c4.svg";